import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from 'json2typescript';
import { BaseResponse } from '../base-response';

@JsonConverter
export class AmplifierGainConverter implements JsonCustomConvert<AmplifierGain> {
  serialize() {}
  deserialize(data: any): AmplifierGain {
    const jsonConvert: JsonConvert = new JsonConvert();
    return jsonConvert.deserializeObject(data, AmplifierGain);
  }
}

@JsonConverter
export class AmplifierItemComponentConverter implements JsonCustomConvert<AmplifierItemComponent> {
  serialize() {}
  deserialize(data: any): AmplifierItemComponent {
    const jsonConvert: JsonConvert = new JsonConvert();
    return jsonConvert.deserializeObject(data, AmplifierItemComponent);
  }
}

@JsonConverter
export class AmplifierItemComponentArrayConverter implements JsonCustomConvert<Array<AmplifierItemComponent>> {
  serialize() {}
  deserialize(data: any): Array<AmplifierItemComponent> {
    const jsonConvert: JsonConvert = new JsonConvert();
    return jsonConvert.deserializeArray(data, AmplifierItemComponent);
  }
}

@JsonConverter
export class AmplifierConverter implements JsonCustomConvert<Amplifier> {
  serialize() {}
  deserialize(data: any): Amplifier {
    const jsonConvert: JsonConvert = new JsonConvert();
    return jsonConvert.deserializeObject(data, Amplifier);
  }
}

@JsonConverter
export class AmplifierArrayConverter implements JsonCustomConvert<Array<Amplifier>> {
  serialize() {}
  deserialize(data: any): Array<Amplifier> {
    const jsonConvert: JsonConvert = new JsonConvert();
    return jsonConvert.deserializeArray(data, Amplifier);
  }
}

@JsonConverter
export class AmplifierCountListConverter implements JsonCustomConvert<AmplifierCountList> {
  serialize() {}
  deserialize(data: any): AmplifierCountList {
    const jsonConvert: JsonConvert = new JsonConvert();
    return jsonConvert.deserializeObject(data, AmplifierCountList);
  }
}

@JsonObject('AmplifierGain')
export class AmplifierGain {
  @JsonProperty('freq_24', Number, true)
  freq_24: number = 0;

  @JsonProperty('freq_5', Number, true)
  freq_5: number = 0;

  @JsonProperty('freq_6', Number, true)
  freq_6: number = 0;
}

@JsonObject('AmplifierItemComponent')
export class AmplifierItemComponent {
  @JsonProperty('code', String, true)
  code: string = '';

  @JsonProperty('value', Number, true)
  value: number = 0;
}

@JsonObject('Amplifier')
export class Amplifier {
  @JsonProperty('amplifierId', Number, true)
  amplifierId: number = 0;

  @JsonProperty('name', String, true)
  name: string = '';

  @JsonProperty('gain', AmplifierGainConverter, true)
  gain: AmplifierGain = new AmplifierGain();

  @JsonProperty('note', String, true)
  note: string = '';

  @JsonProperty('components', AmplifierItemComponentArrayConverter, true)
  components: AmplifierItemComponent[] = [];
}

@JsonObject('AmplifierCountList')
export class AmplifierCountList {
  @JsonProperty('count', Number, true)
  count: number = 0;

  @JsonProperty('items', AmplifierArrayConverter, true)
  items: Amplifier[] = [];
}

@JsonObject('AmplifierData')
export class AmplifierData extends BaseResponse {
  @JsonProperty('data', AmplifierConverter, true)
  data: Amplifier = new Amplifier();
}

@JsonObject('AmplifierDataArray')
export class AmplifierDataArray extends BaseResponse {
  @JsonProperty('data', AmplifierCountListConverter, true)
  data: AmplifierCountList = new AmplifierCountList();
}
